export enum BadRequestError {
	NotMatchPreviousPassword = 'Must not match the previous password',
}
